import script from "./MedicalAlerts.vue?vue&type=script&lang=ts&setup=true"
export * from "./MedicalAlerts.vue?vue&type=script&lang=ts&setup=true"

import "./MedicalAlerts.vue?vue&type=style&index=0&id=01ed8c32&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01ed8c32"]])

export default __exports__